import "./menu.js";
import "./hpslider.js";
import "./tip.js";
import "./copy.js";
// import './qty.js';
// import './sameHeight.js';
import "./star-rating.js";
import "./product-box.js";
import "./productbox-slider.js";
import "./alert.js";
// import './demo.js';
import "lite-youtube-embed";

const backdropActiveClass = "site__backdrop--show";

/**
 * whisper
 */
const ready = async (callback) => {
  if (document.readyState !== "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};

let lazyLoad = null;

const lazyLoadUpdate = () => {
  lazyLoad?.update();
};

ready(async () => {
  let { stickyProductNavInit } = await import(
    "./common/product/sticky-product-nav"
  );
  setTimeout(() => {
    stickyProductNavInit();
  }, 5000);

  let { autocompleteHoverInit, autocompleteInit } = await import(
    "./common/autocomplete.js"
  );
  await autocompleteInit();
  await autocompleteHoverInit();

  let { modalInit } = await import("./common/modal");

  const { filterLinksUrl } = await import("./filterLinksUrl.js");
  filterLinksUrl().then(async () => {
    let { Filter } = await import("./filter");
    new Filter(
      "/api/v1/filter",
      "productFilter-link",
      "productFilter-select",
      "productFilter-price",
      "productFilter-filter",
      "productFilter-products",
      "productFilter-orderer",
      "productFilter-link--orderer",
      "productFilter-count",
      "productFilter-pager",
      "productFilter-pagerBottom",
      "productFilter-link--pager",
      "productFilter-showMore",
      "productFilter-showMoreWrapper",
      "productFilter-nextLink",
      "productFilter-not-found",
      "js-site-backdrop",
      "productFilter-selectedFilter",
      "productFilter-clearSelected",
      "productFilter-clear",
      "productFilter-settings",
      "productFilter-h1",
      "productFilter-description",
      "productFilter-additionalDescription",
      "productFilter-shortDescription",
      () => lazyLoadUpdate()
    );
    modalInit();
  });

  let { OrderPayment } = await import("./order/orderPayment");
  new OrderPayment({
    modalId: "order-payment-modal",
    modalTriggerClass: "js-order-payment-modal",
    orderAlertId: "js-order-alert",
  });

  let { OrderCancel } = await import("./order/orderCancel");
  new OrderCancel({
    modalId: "cancel-order-modal",
    modalTriggerId: "js-cancel-order-modal",
    modalSubmitId: "cancel-order-modal-submit",
    orderAlertId: "js-order-alert",
  });

  let { OrderItemCancel } = await import("./order/orderItemCancel");
  new OrderItemCancel({
    previewTriggerId: "js-cancel-order-item-preview-modal",
    modalId: "cancel-order-item-modal",
    modalTriggerId: "js-cancel-order-item-modal",
    modalSubmitId: "cancel-order-item-modal-submit",
    orderAlertId: "js-order-alert",
  });

  let { productGalleryInit } = await import(
    "./common/product/product-gallery.js"
  );
  productGalleryInit();

  let { BranchGallery } = await import("./branch-gallery");
  new BranchGallery({
    galleryId: "branchGallery",
    modalId: "branchGalleryModal",
  });

  let { submitReviewFormInit, submitRequestFormInit } = await import(
    "./common/product/product-form"
  );
  submitReviewFormInit();
  submitRequestFormInit();

  const descriptionPromoBlocks = document.querySelectorAll(
    ".js-promo-block-description"
  );
  descriptionPromoBlocks.forEach((promoBlock) => {
    const code = promoBlock.getAttribute("data-code");
    const source = document.querySelector(
      '.js-promo-block-source[data-code="' + code + '"]'
    );

    if (source) {
      promoBlock.innerHTML = source.innerHTML;
    }
  });

  let {
    descriptionPromoBlocksDescriptionInit,
    glidePromoBlockDescriptionInit,
  } = await import("./promoblocks.js");
  descriptionPromoBlocksDescriptionInit();
  glidePromoBlockDescriptionInit();

  const { loadProducts } = await import("./common/product/products");
  loadProducts(() => lazyLoadUpdate());
  const { loadCategoryTree } = await import("./common/category-tree");
  loadCategoryTree(() => lazyLoadUpdate());
  const { loadCategoryTreeList } = await import("./common/category-tree-list");
  loadCategoryTreeList(() => lazyLoadUpdate());
  const { loadKeyBrands } = await import("./common/key-brands");
    loadKeyBrands(async () => {
        lazyLoadUpdate()
        const { glideBrandsInit } = await import("./common/glide/glide-brands");
        glideBrandsInit();
    });
  const { loadMostSearchedBrands } = await import(
    "./common/most-searched-brands"
  );
    loadMostSearchedBrands(async () => {
        lazyLoadUpdate()
        const { glideBrandsInit } = await import("./common/glide/glide-brands");
        glideBrandsInit();
    });
  const { loadAdvisoryLinks } = await import("./common/advisory-links");
  loadAdvisoryLinks(() => lazyLoadUpdate());
  const { loadPagePreviewList } = await import("./common/page-preview-list");
  loadPagePreviewList(() => lazyLoadUpdate());
  const { accordionScrollInit } = await import("./common/accordion-scroll");
  accordionScrollInit();

  /**
   * Service option lists
   */
  const serviceOptionList = document.querySelectorAll(".service-option-list");
  if (serviceOptionList.length) {
    let { ServiceOptionList } = await import("./serviceOptionList");
    serviceOptionList.forEach((wrapper) => {
      new ServiceOptionList({ wrapper });
    });
  }

  let { headRoomInit } = await import("./common/headroom.js");
  headRoomInit();

  // TODO: zkontrolovat zda se to vůbec používá
  let { glideProductBoxInit } = await import(
    "./common/glide/glide-product-box"
  );
  glideProductBoxInit();

  let { glideProductListInit } = await import(
    "./common/glide/glide-product-list"
  );
  glideProductListInit();

  let { glideProductListSmallInit } = await import(
    "./common/glide/glide-product-list-small.js"
  );
  glideProductListSmallInit(40);

  let { glideModelListInit } = await import("./common/glide/glide-model-list");
  glideModelListInit();
  // TODO: zkontrolovat zda se to vůbec používá
  let { glideVendorInit } = await import("./common/glide/glide-vendor");
  glideVendorInit();

  let { glideVideoInit } = await import("./common/glide/glide-video");
  glideVideoInit();

  let { glideLockerRoomInit } = await import(
    "./common/glide/glide-locker-room"
  );
  glideLockerRoomInit();
  // TODO: zkontrolovat zda se to vůbec používá

  let { glideIgPostsInit } = await import("./common/glide/glide-ig-posts");
  glideIgPostsInit();

  let { glideCompareInit } = await import("./common/glide/glide-compare");
  glideCompareInit();

  let { compareTabInit } = await import("./common/product/compare-tab");
  compareTabInit();

  let { formControllInit } = await import("./common/form-controll.js");
  formControllInit();

  let { tooltipInit } = await import("./common/tooltip");
  let { popoverInit } = await import("./common/popover");
  tooltipInit();
  popoverInit();

  let { countdownInit } = await import("./common/countdown-controller.js");
  countdownInit();

  /**
   * Range
   */
  /**
   * Range slider
   */
  // const priceSliders = document.querySelectorAll('.price-slider');
  // priceSliders.forEach((priceSlider) => {
  //     let handle = priceSlider.querySelector('.price-slider-handle');
  //     let min = priceSlider.querySelector('.price-slider__min span');
  //     let max = priceSlider.querySelector('.price-slider__max span');
  //     let dataValues = [min, max]
  //
  //     let start = parseInt(min.getAttribute('data-selected'));
  //     let end = parseInt(max.getAttribute('data-selected'));
  //
  //     if (!start) {
  //         start = parseInt(min.textContent);
  //     }
  //
  //     if (!end) {
  //         end = parseInt(max.textContent);
  //     }
  //
  //     noUiSlider.create(handle, {
  //         start: [Math.max(parseInt(min.textContent), start), Math.min(parseInt(max.textContent), end)],
  //         connect: [false, true, false],
  //         range: {
  //             'min': [parseInt(min.textContent)],
  //             'max': [parseInt(max.textContent)]
  //         }
  //     });
  //
  //     handle.noUiSlider.on('update', function (values, handle) {
  //         dataValues[handle].innerHTML = ~~ (values[handle]);
  //     });
  // });

  let { stickFilterButtonInit } = await import(
    "./common/stick-filter-button.js"
  );
  stickFilterButtonInit();

  let { scrollAnywhereInit } = await import("./common/scroll-anywhere");
  scrollAnywhereInit();

  let { productScrollInit } = await import("./common/product/product-scroll");
  productScrollInit();

  let { drowpdowOverlayInit } = await import("./common/dropdown-overlay.js");
  drowpdowOverlayInit();

  let { drowpdowHoverInit } = await import("./common/dropdown-hover.js");
  drowpdowHoverInit();

  const { dropdownInit } = await import("./common/dropdown");
  dropdownInit();

  // /**
  //  * Toggle select n radio
  //  */
  // const inputs = document.querySelectorAll('[data-js-toggle]');
  // inputs.forEach(input => {
  //     input.addEventListener('change', () => {
  //         let targetIdentifier = input.getAttribute('data-js-toggle');
  //         let targetList = document.querySelectorAll(targetIdentifier);
  //         let value = input.getAttribute('data-js-display');

  //         targetList.forEach(target => {
  //             target.style.display = value;
  //         });
  //     });
  // });

  let { initLazyLoad } = await import("./common/lazyload.js");
  lazyLoad = await initLazyLoad();

  let { jsHpMenuInit } = await import("./common/js-hp-menu.js");
  jsHpMenuInit();

  let { jsSubmenuInit } = await import("./common/js-submenu.js");
  jsSubmenuInit(() => lazyLoadUpdate());

  let { searchBoxFocusInit } = await import("./common/search-box.js");
  searchBoxFocusInit();

  let { siteBarAlertInit } = await import("./common/site-bar-alert.js");
  siteBarAlertInit();

  let { truncateLinesInit } = await import("./common/truncate-lines.js");
  truncateLinesInit();

  let { collapseInit } = await import("./common/collapse");
  collapseInit();

  modalInit();

  const { initNewsletter } = await import("./common/newsletter");
  initNewsletter();

  const { initYoutubeVideo } = await import("./common/yt-video");
  initYoutubeVideo();

  const { KlarnaOnsiteMessaging } = await import(
    "./klarna/klarna-onsite-message"
  );
  new KlarnaOnsiteMessaging("klarna-message");

  const { removeSearchParamInUrlAndHistory } = await import(
    "./common/remove-search-param"
  );
  setTimeout(() => removeSearchParamInUrlAndHistory("_fid"), 200);

  const { initPaddingTopSiteContent } = await import("./common/site-content");
  initPaddingTopSiteContent();

  const { openModalByUrlParams } = await import(
    "./common/product/review-modal"
  );
  openModalByUrlParams();
});
